import { Tabs } from "antd";
import classNames from "classnames";
import { CommonTabProps } from "@/types";

export default function CommonTabs(props: CommonTabProps) {
  const {
    className,
    active,
    tabs,
    onTabChange,
    size = "middle",
    hasContent = false,
    tabBarExtraContent,
  } = props;
  return (
    <div className={classNames(className)}>
      <Tabs
        className={classNames(
          "global__common-tabs",
          hasContent ? "" : "global__common-tabs-no-content",
          className,
        )}
        activeKey={active}
        onChange={onTabChange}
        tabBarExtraContent={tabBarExtraContent}
        defaultActiveKey="1"
        items={tabs}
        hideAdd={true}
        size={size}
      />
    </div>
  );
}
